import { render, staticRenderFns } from "./EventId.vue?vue&type=template&id=0bf6295c&scoped=true"
import script from "./EventId.vue?vue&type=script&lang=js"
export * from "./EventId.vue?vue&type=script&lang=js"
import style0 from "./EventId.vue?vue&type=style&index=0&id=0bf6295c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf6295c",
  null
  
)

export default component.exports